import { render, staticRenderFns } from "./ClientFares.vue?vue&type=template&id=397e176d&scoped=true&"
import script from "./ClientFares.vue?vue&type=script&lang=js&"
export * from "./ClientFares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e176d",
  null
  
)

export default component.exports